<template>
<button>
  <slot>{{buttontext}}</slot>
</button>
</template>

<script>
export default {
  name: 'Button',
  components: {

  },
  props: {
    buttontext: null,
  },
  data() {
    return {

    };
  },
};
</script>

<style lang="scss"  scoped>
button {
    border-radius: 4px;
    background-color: #F83C5B;
    border: none;
    cursor: pointer;
    display: block;
    font-weight: normal;
    padding: 15px 0;
    width: 100%;
    color: #fff;
    font-size: 16px;
    line-height: 20px;
    transition: all .2s ease-in;

    @screen md {
      font-size: 18px;
    }

    &:hover {
      transition: all .2s ease-in;
      background-color: #fd4664;
    }

}
</style>
